import useProductosPrecargadosN2 from "./useProductosPrecargadosN2";

/**
 * Hook que precarga los productos de cada grupo activo de Nave 2, para imprimir desde
 * el listado sus etiquetas (la de altura / Tronja 3 incluida, si toca) sin esperar.
 *
 * DECISION: caché por ejercicio + grupo + pedidos. El listado se refresca cada 30 s
 * con objetos nuevos, pero un grupo solo se vuelve a cargar si cambian sus pedidos.
 * Supone una petición por pedido de cada grupo al abrir la pantalla.
 *
 * @param {Array} grupos - Grupos activos (id, pedidos [{numero, tipo}])
 * @returns {Object<number, Array|null|undefined>} Productos por id de grupo: `undefined`
 *   mientras carga, `null` si la carga falló
 */
const useProductosGruposN2 = (grupos) => useProductosPrecargadosN2(grupos, 'grupo');

export default useProductosGruposN2;
